import { render, staticRenderFns } from "./DATA_ANALYSISED.vue?vue&type=template&id=2e98117c&"
import script from "./DATA_ANALYSISED.vue?vue&type=script&lang=js&"
export * from "./DATA_ANALYSISED.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports